var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_2955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83333 14.1667V15.8333C3.83333 16.2754 4.03527 16.6993 4.39471 17.0118C4.75416 17.3244 5.24167 17.5 5.75 17.5H17.25C17.7583 17.5 18.2458 17.3244 18.6053 17.0118C18.9647 16.6993 19.1667 16.2754 19.1667 15.8333V14.1667",
    stroke: "white",
    strokeWidth: 1.25768,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70833 9.16667L11.5 13.3333L16.2917 9.16667",
    stroke: "white",
    strokeWidth: 1.25768,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.33333V13.3333",
    stroke: "white",
    strokeWidth: 1.25768,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_2955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadWhite);
export default __webpack_public_path__ + "static/media/Icon_Download_White.327ac9c47f9add4d39116f34981f867a.svg";
export { ForwardRef as ReactComponent };